import { useState, useRef, useEffect } from "react";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";
import classes from "./BankBankRecon.module.css";
import { Calendar } from "lucide-react";
import printer from "../../Assets/Printer.png";
import tick from "../../Assets/check.png";
import refresh from "../../Assets/ArrowsClockwise.png";
import save from "../../Assets/FloppyDisk.png";
import cancel from "../../Assets/X.png";
import uploadbtn from "../../Assets/UploadSimple.png";
import downloadbtn from "../../Assets/DownloadSimple.png";
import chat from "../../Assets/ChatCircle.png";
import Footer from "../../Components/Footer/Footer";
import { Link } from "react-router";

const ReconciliationLedger = () => {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState("Current Month");
  const inputRef = useRef(null);
  const wrapperRef = useRef(null);

  const handleClickOutside = (e) => {
    if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleCalendarClick = (e) => {
    e.stopPropagation();
    inputRef.current.showPicker(); // shows native picker in modern browsers
  };

  const handleMonthChange = (e) => {
    const [year, month] = e.target.value.split("-");
    const monthName = new Date(e.target.value).toLocaleString("default", {
      month: "long",
    });
    setSelectedMonth(`${monthName} ${year}`);
  };
  return (
    <div className={classes.bodyxyz}>
      <HeaderNav />
      <section className={classes.bankbody}>
        {/* <div className={classes.actions}>
          <Link to='/transactions/sales-invoice/sales'><button className={classes.btns}>Sales Invoice</button></Link>
          <Link to='/inventory/purchaseOrder'><button className={classes.btns}>Purchase order</button></Link>
          <button className={classes.btnst}>Reconcilation</button>
          <Link to='/settings/product-services'><button className={`${classes.btns} ${classes.greens}`}>Product & Services</button></Link>
        </div> */}

        <header className={classes.header}>
          <div className={classes.header1}>
            <h2 className={classes.Title}>Bank Reconcillation</h2>
            <h1 className={classes.Titles}>
              Match your ledger transactions with bank statements.
            </h1>
          </div>
          <div className={classes.header2}>
            <div className={classes.wrapper} ref={wrapperRef}>
              <div
                className={classes.combobox}
                onClick={() => setDropdownOpen(!dropdownOpen)}
              >
                <Calendar
                  className={classes.icon}
                  onClick={handleCalendarClick}
                />
                <span className={classes.label}>{selectedMonth}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className={classes.chevron}
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.23 7.21a.75.75 0 011.06.02L10 11.293l3.71-4.06a.75.75 0 011.1 1.02l-4.25 4.65a.75.75 0 01-1.1 0l-4.25-4.65a.75.75 0 01.02-1.06z"
                    clipRule="evenodd"
                  />
                </svg>
                <input
                  type="month"
                  ref={inputRef}
                  onChange={handleMonthChange}
                  className={classes.hiddenInput}
                />
              </div>
            </div>
          </div>
        </header>
      </section>
      <section className={classes.cardsect}>
        <div className={classes.reconciliationContainer}>
          <div className={classes.amountDisplay}>
            <span className={classes.amountValue}>0.00</span>
            <select className={classes.filterDropdown}>
              <option>All Matched Items</option>
            </select>
            <div className={classes.actionIcons}>
              <button className={classes.iconBtn} title="Print">
                {/* <span>🖨️</span> */}
                <img src={tick} alt="Print" className={classes.icon} />
              </button>
              <button className={classes.iconBtn} title="Print">
                {/* <span>🖨️</span> */}
                <img src={printer} alt="Print" className={classes.icon} />
              </button>
              <button className={classes.iconBtn} title="Share">
                {/* <span>📤</span> */}
                <img src={save} alt="Share" className={classes.icon} />
              </button>
              <button className={classes.iconBtn} title="Refresh">
                {/* <span>🔄</span> */}
                <img src={refresh} className={classes.icon} />
              </button>
              <button className={classes.iconBtn} title="Close">
                <span>✕</span>
              </button>
            </div>
          </div>

          <div className={classes.twoColumnLayout}>
            {/* LEDGER COLUMN */}
            <div className={classes.column}>
              <div className={classes.columnHeader}>
                <h3 className={classes.columnTitle}>LEDGER</h3>
                <div>   
                  <p className={classes.balance}>BALANCE</p>
                <p className={classes.balanceAmount}>₦16,400,000</p>
                </div>
                
              </div>
              
              <input
                type="text"
                placeholder="Search details or amount..."
                className={classes.searchBox}
              />

              <div className={classes.tableWrapper}>
                <table className={classes.transactionTable}>
                  <thead>
                    <tr>
                      <th><input type="checkbox" /></th>
                      <th>POST DATE</th>
                      <th>VAL DATE</th>
                      <th>DETAILS</th>
                      <th>AMOUNT</th>
                      <th>ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[...Array(25)].map((_, i) => (
                      <tr key={i}>
                        <td><input type="checkbox" /></td>
                        <td>29 Feb 2026</td>
                        <td>29 Feb 2026</td>
                        <td><span className={classes.offeringBadge}>Offering</span></td>
                        <td>300,000.00</td>
                        <td>
                          <div className={classes.actionCell}>
                            <button className={classes.actionIconBtn}><img src={uploadbtn} className={classes.icon} /></button>
                            <button className={classes.actionIconBtn}><img src={downloadbtn} className={classes.icon} /></button>
                            <button className={classes.actionIconBtn}><img src={chat} className={classes.icon} /></button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className={classes.pagination}>
                <button className={classes.paginationBtn}>‹</button>
                <span className={classes.pageIndicator}>1</span>
                <span className={classes.pageNumber}>2</span>
                <button className={classes.paginationBtn}>›</button>
              </div>
            </div>

            {/* BANK STATEMENT COLUMN */}
            <div className={classes.column}>
              <div className={classes.columnHeader}>
                <h3 className={classes.columnTitle}>BANK STATEMENT</h3>
                <div>
                  <p className={classes.balance}>BALANCE</p>
                <p className={classes.balanceAmount}>₦16,400,000</p>
                </div>
                
              </div>
              
              <input
                type="text"
                placeholder="Search details or amount..."
                className={classes.searchBox}
              />

              <div className={classes.tableWrapper}>
                <table className={classes.transactionTable}>
                  <thead>
                    <tr>
                      <th><input type="checkbox" /></th>
                      <th>POST DATE</th>
                      <th>VAL DATE</th>
                      <th>DETAILS</th>
                      <th>AMOUNT</th>
                      <th>ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[...Array(25)].map((_, i) => (
                      <tr key={i}>
                        <td><input type="checkbox" /></td>
                        <td>29 Feb 2026</td>
                        <td>29 Feb 2026</td>
                        <td><span className={classes.offeringBadge}>Offering</span></td>
                        <td>300,000.00</td>
                        <td>
                          <div className={classes.actionCell}>
                            <button className={classes.actionIconBtn}><img src={uploadbtn} className={classes.icon} /></button>
                          <button className={classes.actionIconBtn}><img src={downloadbtn} className={classes.icon} /></button>
                          <button className={classes.actionIconBtn}><img src={chat} className={classes.icon} /></button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className={classes.pagination}>
                <button className={classes.paginationBtn}>‹</button>
                <span className={classes.pageIndicator}>1</span>
                <span className={classes.pageNumber}>2</span>
                <button className={classes.paginationBtn}>›</button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default ReconciliationLedger;
